import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
    trackAccountCreated,
} from "../utils/analytics";

import {
    createAccount,
    loginWithGoogle,
} from "../services/auth";

import { Capacitor } from "@capacitor/core";

export default function Signup() {
    const navigate = useNavigate();

    const [displayName, setDisplayName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [emailUpdates, setEmailUpdates] = useState(false);

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const isNative = Capacitor.isNativePlatform();

    async function handleSubmit(e) {
        e.preventDefault();

        setError("");

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            setLoading(true);

            await createAccount({
                displayName,
                email,
                password,
                emailUpdates,
            });
            localStorage.removeItem("completedActivities");

            trackAccountCreated("email");
          
            navigate("/");
        } catch (err) {
            switch (err.code) {
                case "auth/email-already-in-use":
                    setError("That email is already registered.");
                    break;

                case "auth/weak-password":
                    setError("Password should be at least 6 characters.");
                    break;

                case "auth/invalid-email":
                    setError("Please enter a valid email address.");
                    break;

                default:
                    console.error(err);
                    setError(err.message);
            }
        } finally {
            setLoading(false);
        }
    }
    async function handleGoogleSignup() {

        setError("");

        try {

            const result = await loginWithGoogle();

            if (result.isNewUser) {
                trackAccountCreated("google");
            }

            navigate("/");

        } catch (err) {

            console.error(err);
            setError(err.message);

        }

    }
    return (
        <div
    className="page"
    style={{
        paddingTop: "calc(env(safe-area-inset-top) + 16px)",
        paddingLeft: "1rem",
        paddingRight: "1rem",
    }}
>
           <Link
    to="/"
    style={{
        display: "inline-block",
        marginTop: "40px"
    }}
>
    ← Home
</Link>
            <h1>Save Your Progress</h1>
            <p>Create a free account to save progress and view learning journal.</p>
            {!isNative && (
                <>
                    <button
                        type="button"
                        onClick={handleGoogleSignup}
                    >
                        Continue with Google
                    </button>

                    <p style={{ textAlign: "center" }}>
                        — or —
                    </p>
                </>
            )}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Name (optional)</label>
                    <input
                        value={displayName}
                        onChange={(e) =>
                            setDisplayName(e.target.value)
                        }
                    />
                </div>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        required
                    />
                </div>
                <div>
                    <label>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                        required
                    />
                </div>
                <div>
                    <label>Confirm Password</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) =>
                            setConfirmPassword(e.target.value)
                        }
                        required
                    />
                </div>
                <label>
                    <input
                        type="checkbox"
                        checked={emailUpdates}
                        onChange={(e) =>
                            setEmailUpdates(e.target.checked)
                        }
                    />

                    I'd like occasional emails about new activities, features and updates.
                </label>

                {error && (
                    <p style={{ color: "red" }}>
                        {error}
                    </p>
                )}

                <button
                    type="submit"
                    disabled={loading}
                >
                    {loading
                        ? "Creating..."
                        : "Create Account"}
                </button>

            </form>

            <p>
                Already have an account?{" "}
                <Link to="/login">
                    Log in
                </Link>
            </p>
        </div>
    );
}